code

<template>

  <div class="container">
    <div class="row fh-row justify-content-center">
      <div class="col-md-6 pl-0 pr-0 align-self-center">
        <mdb-card class="z-depth-1 card-height">
          <mdb-card-header color="white">
            <div class="container-fluid">
              <div class="row">
                <div :class="$store.state.reseller_logo? 'col-6': 'col-3'" class="col-md-4 align-self-center text-left">
                  <img v-if="$store.state.reseller_logo" src="@/assets/truid_logo.svg" alt="Card image cap" class="img-fluid"/>
                </div>
                <div :class="$store.state.reseller_logo? 'col-2': 'col-6'" class="col-md-4">
                  <img v-if="!$store.state.reseller_logo" src="@/assets/truid_logo.svg" alt="Card image cap" class="img-fluid"/>
                </div>
                <div :class="$store.state.reseller_logo? 'col-4': 'col-3'" class="col-md-4 col-4 align-self-center text-right">
                  <img v-if="$store.state.reseller_logo" :src="$store.state.reseller_logo" alt="Card image cap" class="img-fluid img-banner"/>
                </div>
              </div>
            </div>
          </mdb-card-header>
          <mdb-card-body class="text-center">
              <div class="container-fluid">
                <div class="row">
                  <div class="col-12 align-self-center">
                    <mdb-progress class="mb-3" style="width: 100%; float:left"
                                  :height="20" :value="$store.state.step/$store.state.totalSteps * 100">
                      {{ $store.state.step }}/{{ $store.state.totalSteps }}
                    </mdb-progress>
                  </div>
                </div>
              <form ref="f">
                <div class="row hh-row">
                  <div class="col-12 align-self-center mb-3">
                    <h4>{{ message }}</h4>
                  </div>
                  <div
                      v-for="item in options"
                      :key="item"
                      class="col-12 align-self-center mb-3">
                    <mdb-btn
                        @click="selectOption(item)"
                        style="font-size: 15px"
                        block :color="name === item || city === item? 'primary': 'white'" size="md">
                      {{ item }}
                    </mdb-btn>
                  </div>
                  <div class="col-12 align-self-center">
                    <div class="row justify-content-center">
                      <transition name="slide-fade">
                        <p class="text-danger" v-if="show && firstStep === 'name'">{{ $t("selectNameMsg") }}</p>
                        <p class="text-danger" v-if="show && firstStep === 'city'">{{ $t("selectCityMsg") }}</p>
                        <p v-else><b>{{ $t("selectCarefullyMsg") }}</b></p>
                      </transition>
                    </div>
                  </div>
                </div>
              </form>
              </div>
          </mdb-card-body>
          <mdb-card-footer>
            <div class="col-12 align-self-center">
              <div class="row justify-content-center">
                <div class="col-md-12 mb-1 ">
                  <mdb-btn
                      :disabled="!((this.name && !this.firstStep) || (this.city && this.firstStep))"
                      style="font-size: 15px" block color="primary" class="next-btn" size="md" @click="navigate">
                    {{ $t("next") }}
                    <i style="font-size: 22px" class="fa-arrow-right fas fa-2x float-right"></i>
                  </mdb-btn>
                </div>
              </div>
            </div>
          </mdb-card-footer>
        </mdb-card>
      </div>
    </div>
    <div id="overlay" v-if="spinner">
      <div style="position: fixed;top: 50%;left: 45%; width: 10%;" class="text-center text-white">
        <div class="spinner-border" role="status">
          <span class="sr-only">Loading...</span>

        </div>
        <p>{{ $t("waitMsg") }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import {i18n} from "../../translations";

export default {
  name: "InfoVerification",
  data() {
    return {
      message: this.$t("motherNameMsg"),
      names: [],
      show: false,
      options: [],
      name: null,
      city: null,
      spinner: false,
      spinner_message: "",
      cities: [],
      firstStep: false,
    };
  },
  mounted() {
    i18n.locale = this.$store.state.language
    this.$store.commit('assignStep', this.$route.path)
    this.getVerificationInfo()
  },
  methods: {
    getVerificationInfo() {
      this.spinner = true;
      let formData = new FormData();
      formData.append('session', this.$store.state.session_id);
      this.$http.post("/verification-info", formData).then(r => {
        if (r.data.names && r.data.cities) {
          this.names = r.data.names
          this.cities = r.data.cities
          this.options = this.names
          this.spinner = false;
        }
      }).catch(err => {
        this.handleError(err)
      })
    },
    handleError(err) {
      this.spinner = false;
      if (err.response.status === 400){
        if ('non_field_errors' in err.response && err.response.non_field_errors.length>0){
          this.showError(err.response.non_field_errors[0])
        }
        else if ('data' in err.response){
          if ('non_field_errors' in err.response.data && err.response.data.non_field_errors.length>0){
            this.showError(err.response.data.non_field_errors[0])
          }
          else{
            this.showError(JSON.stringify(err.response.data))
          }

        }
        else{
          this.showError(JSON.stringify(err.response))
        }
      } else if (err.response && err.response.status === 401) {
        this.$router.push('/expired')
      }
      else {
        this.showError(err.response)
      }
    },
    showError(message, cancelButton=false) {
      const options = {
        title: message,
        text: this.$t("retryQuestion"),
        icon: 'question',
        showCancelButton: cancelButton,

        confirmButtonText: this.$t("yes"),
        cancelButtonText: this.$t("no"),
        allowOutsideClick: false,
        allowEscapeKey: false,
        focusConfirm: false,
        customClass: {
          confirmButton: "btn btn-primary btn-md ripple-parent",
          cancelButton: "btn  btn-md ripple-parent"
        },
        buttonsStyling: false,
      };

      this.$swal.fire(options).then(res => {
        if (res.value) {
          window.location.reload();
          // eslint-disable-next-line no-undef
        }
      })

    },
    navigate() {
      if ((this.name && !this.firstStep) || (this.city && this.firstStep)) {
        if (!this.firstStep) {
          this.message = this.$t("pobMsg")
          this.options = this.cities
          this.$store.commit('assignStep', this.$route.path)
          this.firstStep = true
          this.show = false
        } else {
          this.spinner = true;
          let formData = new FormData();
          formData.append('session', this.$store.state.session_id);
          formData.append('name', this.name);
          formData.append('city', this.city);
          formData.append('language', this.$store.state.language);
          this.$http.post("/verify-name-city", formData).then(r => {
            if (r.data.status === true) {
              const urlSearchParams = new URLSearchParams(window.location.search);
              const params = Object.fromEntries(urlSearchParams.entries());
              this.$router.push({path:this.$store.state.configPath[this.$store.state.step],query:params})
              this.spinner = false;
            } else {
              this.$router.push('/complete')
            }
          }).catch(err => {
            this.handleError(err)
          })
        }
      } else {
        this.show = true
      }

    },
    selectOption(item) {
      if (!this.firstStep) {
        this.name = item
      } else {
        this.city = item
      }
    }
  }
}
</script>

<style scoped>

</style>
